import React, { useState } from 'react'
import Navbar from './Navbar'
import userData from '../userData'
import Footer from './Footer'
// import image from "../images"
import { useNavigate } from 'react-router-dom'
import "../css/adoptForm.css"
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { useParams } from 'react-router-dom'
import axios from 'axios'
import { useEffect } from 'react'


function AdoptForm() {
  const params = useParams();
  const petid = params.petid;


  const [user, setUser] = useState({});
  async function callAboutPage() {
    try {
      const response = await axios.get('https://petme.onrender.com/about', {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        withCredentials: true,
      });

      const data = response.data;
      setUser(data);
    } catch (error) {
      // Handle error
      console.error(error);
    }
  }

  useEffect(() => {
    callAboutPage();
  }, []);


  const nevigate = useNavigate();
  const [question, setQuestion] = useState({

    question1: '',
    question2: '',
    question3: '',
    question4: '',
    question5: '',
    question6: '',
    question7: '',
    question8: '',
    question9: '',
    question10: ''
  })

  const handleChange = (e) => {

    const { name, value } = e.target
    setQuestion({ ...question, [name]: value })
  }

  const answer = async (e) => {
    e.preventDefault()

    const { question1, question2, question3, question4, question5, question6, question7, question8, question9, question10 } = question;
    const res = await fetch("https://petme.onrender.com/question", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem('token')}`

      },
      body: JSON.stringify({
        question1, question2, question3, question4, question5, question6, question7, question8, question9, question10, petid
      })
    });

    const data = await res.json();

    if (data.status === 422 || !data) {
      window.alert(data.error);
    } else {
      window.alert("Answer Submited Successfully")
    }

    nevigate("/home")

  }







  return (
    <div>

      <Navbar />

      <Carousel>

        <div className="adoption-questionnaire-slides">
          <div className="adoption-questionnaire-img">
            <div className="adoption-slide-1">
              <h1 className="adoption-questinnaire-heading">Adoption Questionnaire</h1>
              <p className="adoption-questionnaire-msg">Please kindly fill the Adoption Questonnaire to become an approved  user for adoption.
                <br />
                and
                <br />
                Thank you for opening your heart and home to a precious soul in need. Your compassion and kindness will not only transform their life, but also fill your days with unconditional love and unforgettable memories.
              </p>
            </div>
          </div>
        </div>

        <div className="adoption-questionnaire-slides">
          <div className="adoptionQuestions adoption-slide-2">
            <div className="adoption-questionnaire-field">
              <p className="adoption-form-question">Have you owned a pet before? Why is he/she not with you anymore? Tell us about him/her.</p>
              <input id="adoption" type="form" name="question1" value={question.question1} onChange={handleChange} className="adoption-answer-box" placeholder="write your answer here" />
            </div>

            <div className="adoption-questionnaire-field">
              <p className="adoption-form-question">Do you currently have any pet(s) at home? Tell us about him/her/them.</p>
              <input id="adoption" type="form" name="question2" value={question.question2} onChange={handleChange} className="adoption-answer-box" placeholder="write your answer here" />
            </div>

            <div className="adoption-questionnaire-field">
              <p className="adoption-form-question">Are there children in your household? What is age of the children ? Do they like animals?</p>
              <input id="adoption" type="form" name="question3" value={question.question3} onChange={handleChange} className="adoption-answer-box" placeholder="write your answer here" />
            </div>

            <div className="adoption-questionnaire-field">
              <p className="adoption-form-question">What is your living situation (house, apartment, etc.)? What floor do you live on?</p>
              <input id="adoption" type="form" name="question4" value={question.question4} onChange={handleChange} className="adoption-answer-box" placeholder="write your answer here" />
            </div>
          </div>
        </div>

        <div className="adoption-questionnaire-slides">
          <div className="adoptionQuestions adoption-slide-2">
            <div className="adoption-questionnaire-field">
              <p className="adoption-form-question">How is the behavior of your neighbors towards pets?</p>
              <input id="adoption" type="form" name="question5" value={question.question5} onChange={handleChange} className="adoption-answer-box" placeholder="write your answer here" />
            </div>

            <div className="adoption-questionnaire-field">
              <p className="adoption-form-question">Are there any restrictions on pet ownership in your building or neighborhood?</p>
              <input id="adoption" type="form" name="question6" value={question.question6} onChange={handleChange} className="adoption-answer-box" placeholder="write your answer here" />
            </div>

            <div className="adoption-questionnaire-field">
              <p className="adoption-form-question">Are you willing and able to provide daily exercise and outdoor time for the pet? How much time are you going to spend with the pet?</p>
              <input id="adoption" type="form" name="question7" value={question.question7} onChange={handleChange} className="adoption-answer-box" placeholder="write your answer here" />
            </div>

            <div className="adoption-questionnaire-field">
              <p className="adoption-form-question">What are your expectations from adopting a pet?</p>
              <input id="adoption" type="form" name="question8" value={question.question8} onChange={handleChange} className="adoption-answer-box" placeholder="write your answer here" />
            </div>
          </div>
        </div>

        <div className="adoption-questionnaire-slides">
          <div className="adoptionQuestions adoption-slide-2">
            <div className="adoption-questionnaire-field">
              <p className="adoption-form-question">Are there any specific preferences or requirements you have in mind for the pet's behavior or characteristics?</p>
              <input id="adoption" type="form" name="question9" value={question.question9} onChange={handleChange} className="adoption-answer-box" placeholder="write your answer here" />
            </div>

            <div className="adoption-questionnaire-field">
              <p className="adoption-form-question">Are you committed to providing necessary veterinary care, grooming, and training for the pet? If yes, could you please describe briefly how you plan to manage and prioritize these responsibilities.</p>
              <input id="adoption" type="form" name="question10" value={question.question10} onChange={handleChange} className="adoption-answer-box" placeholder="write your answer here" />
            </div>

            <button className="adoption-form-submitBtn" onClick={answer}>SUBMIT</button>
          </div>
        </div>

      </Carousel>

      <Footer />
    </div>
  )
}

export default AdoptForm